import React from 'react'
import PropTypes from 'prop-types'
import RegDataTable from './RegDataTable'
import './RegConfirmation.css'
import { getSubTotal } from '../../config/accountSubscription'
import { AS } from '../../config/account'

const RegConfirmation = ({ regData, accountState }) => {
  const action = accountState === AS.WAITTING_D || accountState === AS.WAITTING_D_OC 
    ? 'aktivována plná verze aplikace Dadopa.'
    : 'obnoveno předplatné.'
  return (
    <div className='cf-con'>
      <h3>Objednávka číslo {regData.orderNo}</h3>
      <p>Stav objednávky: Čeká na zaplacení.</p>
      <p className='cf-inf'>{`Děkujeme za Vaši objednávku. Na vaši adresu byl zaslán e-mail s platebními údaji. Po uhrazení platby vám bude ${action}`}</p>
      <h4>Shrnutí objednávky</h4>
      <RegDataTable regData={regData} />
      <h4>Platební údaje</h4>
      <table className='cf-tab'>
        <tbody>
          <tr><td>Číslo účtu:</td><td>670100-2214449910/6210</td></tr>
          <tr><td>Variabilní symbol:</td><td>{regData.orderNo}</td></tr>
          <tr><td>Datum splatnosti:</td><td>{new Date(regData.dueDate).toLocaleDateString()}</td></tr>
          <tr><td>Částka:</td><td>{getSubTotal(regData.subscription) + ' Kč'}</td></tr>
        </tbody>
      </table>
    </div>
  )
}

RegConfirmation.propTypes = {
  regData: PropTypes.object,
  accountState: PropTypes.string
}

export default RegConfirmation



// WEBPACK FOOTER //
// ./src/components/UserAccount/RegConfirmation.js